import { blueGrey } from '@mui/material/colors';
import { Stack } from '@mui/material';
import People from '@mui/icons-material/People';
import Person from '@mui/icons-material/Person';
import { useTranslation } from 'react-i18next';

import { Text } from '../Text/Text';
import { AccountGroupRole } from '@shared/enums';

interface CustomerRoleTypeBadgeProps {
  accountGroupRole: AccountGroupRole;
  testID: string;
}

export const CustomerRoleTypeBadge = ({ accountGroupRole, testID }: CustomerRoleTypeBadgeProps) => {
  const { t } = useTranslation();

  const getBadgeType = (): 'shared' | 'personal' => {
    if (
      accountGroupRole === AccountGroupRole.Primary ||
      accountGroupRole === AccountGroupRole.Secondary ||
      accountGroupRole === AccountGroupRole.Partner
    ) {
      return 'shared';
    }

    if (accountGroupRole === AccountGroupRole.IndependentPartner) {
      return 'personal';
    }

    throw new Error(`Unsupported account group role: ${accountGroupRole}`);
  };

  const type = getBadgeType();

  const isShared = type === 'shared';
  const label = isShared
    ? t($ => $.shared.customerRoleTypeBadge.shared)
    : t($ => $.shared.customerRoleTypeBadge.personal);

  return (
    <Stack
      alignItems="center"
      data-testid={testID}
      direction="row"
      sx={{
        backgroundColor: blueGrey[50],
        borderRadius: '20px',
        display: 'inline-flex',
        gap: '4px',
        height: '16px',
        justifyContent: 'center',
        padding: '0 8px',
      }}
    >
      {isShared ? (
        <People sx={{ aspectRatio: '1/1', color: blueGrey[900], height: '12px', width: '12px' }} />
      ) : (
        <Person sx={{ aspectRatio: '1/1', color: blueGrey[900], height: '12px', width: '12px' }} />
      )}
      <Text
        category="label-small"
        sx={{
          color: blueGrey[900],
          lineHeight: '13px',
          letterSpacing: '1px',
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Text>
    </Stack>
  );
};
